import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { QueryMalls, QueryMallsVariables } from "./types/QueryMalls";

export const queryMalls = gql`
  ${pageInfoFragment}
  query QueryMalls(
    $after: String
    $brandId: ID
    $first: Int!
    $query: String!
    $statuses: [SmopStatusEnum]
    $isServiceable: Boolean
  ) {
    search: malls(
      after: $after
      first: $first
      filter: {
        search: $query
        brand: $brandId
        statuses: $statuses
        isServiceable: $isServiceable
      }
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<QueryMalls, QueryMallsVariables>(queryMalls);
